import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote, Star } from 'lucide-react';
import { Navigation } from '../components/Navigation';
const testimonials = [{
  name: 'Paul Manudat',
  text: "NWBBA Lynnwood, this is one place we call a Home away from home! One of the main reasons is because of Master Joe. He has welcomed our family into this Dojang with open arms and has made us feel like family from the very first moment we entered the school. My son Anthony, has been training with Coach Brandon, Master Joe and Master Kevin and loves Taekwondo and the sparring team. He rarely every misses a class and is always excited to go. The variety of workouts you get will keep your heart pumping, wear you out and make you want more. This place is number one in my book. The changes in my son's general attitude & performance are significant & noticeable. Mrs. Maria is jet ski office and is a miracle worker, she handles most of if not all the paper work, registration, fundraising, billing. You got questions, she has Answers. Bottom line: This is a Great School to be educated. Come join the family, you won't regret it!"
}, {
  name: 'Ruchi Paul',
  text: "Our 11 year old son started training in Taekwondo at the Northwest Black Belt Academy (NWBBA) almost one year ago. We soon realized that there was a vast difference between Martial art clubs & pro-grade comprehensive martial arts education center like NWBBA. Master Joe and the team of instructors & assistants are serious professionals who are dedicated to developing competitive, well rounded and disciplined athletes of the future. They pay meticulous attention to detail on every student's individual performance and work closely with them to bring out their best. The support staff at NWBBA are caring, kind and helpful. The changes in my son's general attitude & performance are significant & noticeable. We highly recommend NWBBA to all aspiring martial artists!"
}, {
  name: 'Satori Seraier',
  text: 'Through NWBBA, I have gained several strengths, including schedule prioritization and a respectful nature. Including these, my physical strengths have extremely exceeded my original expectations of myself. Emotional intelligence, although unexpected, has also contributed to my performance at NWBBA. All in all, these points contribute at the friendly and productive atmosphere you are immediately surrounding in when entering the dojang.'
}, {
  name: 'Marianne Pedigan',
  text: 'My daughter has been taking Taekwondo for 6 years. She started at another school but just recently moved to NWBBA with Master Joe Whitworth and his outstanding team of instructors. In the short time we have been here, we have been impressed with the caliber of expert instruction our daughter has received. She is excited to learn taekwondo again. She was three weeks away from getting her black belt before we moved schools, but she insists that this was the best decision we have made. She is eager to earn her black belt from Master Joe. She has learned so much and loves it. I am grateful. Master Joe is a great teacher and a wonderful role model. I would recommend this school to anyone. They invest in every penny.'
}, {
  name: 'Eric Miller',
  text: 'NWBBA, is a great place for Taekwondo. Master Joe is an amazing role model and Instructors. It is a great place for kids and adults alike. The discipline and respect that is taught and practiced by the kids is exceptional. Both teachers and parents from school recognize and comment about how polite, courteous, and respectful my daughter is. She stays focused and on task daily and I believe it is from the tenants that are taught at NWBBA. We love the place and would not take our kids anywhere else. We would highly recommend anyone else.'
}, {
  name: 'Kristina Allen',
  text: 'NWBBA has become a home away from home for my family. My daughter is on the competition team, that Master Joe coaches and it has become such a big part of her life. Master Joe and the other instructors know how to motivate, connect, encourage and make our kids better athletes and better human beings. We are so fortunate to have found NWBBA in Lynnwood. Kudos to Master Joe for creating a great program and great environment for our kids!'
}];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
export function ProofPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-357">
      <Navigation data-id="element-358" />

      {/* Hero Section */}
      <section className="pt-16 pb-12 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-359">
        <div className="max-w-6xl mx-auto text-center" data-id="element-360">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-361">
            <div className="flex justify-center gap-1 mb-4" data-id="element-362">
              {[1, 2, 3, 4, 5].map((_, i) => <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" data-id="element-363" />)}
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-[#1e3a8a] mb-4" data-id="element-364">
              Proof
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-365">
              Real stories from real families who've experienced the
              transformative power of NWBBA. These aren't just
              testimonials—they're proof that martial arts changes lives.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 px-4 bg-white" data-id="element-366">
        <div className="max-w-6xl mx-auto" data-id="element-367">
          <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-368">
            {testimonials.map((testimonial, idx) => <motion.div key={idx} variants={fadeIn} className="bg-gray-50 p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-369">
                <Quote className="w-10 h-10 text-[#dc2626] mb-6" data-id="element-370" />
                <p className="text-gray-700 leading-relaxed mb-6 text-base" data-id="element-371">
                  {testimonial.text}
                </p>
                <div className="pt-6 border-t border-gray-200" data-id="element-372">
                  <p className="font-bold text-[#1e3a8a] text-lg" data-id="element-373">
                    {testimonial.name}
                  </p>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-374">NWBBA Parent</p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-[#1e3a8a] text-white text-center" data-id="element-375">
        <div className="max-w-3xl mx-auto" data-id="element-376">
          <h2 className="text-3xl sm:text-4xl font-black mb-6" data-id="element-377">
            Ready to write your own success story?
          </h2>
          <p className="text-blue-100 mb-8 text-lg leading-relaxed" data-id="element-378">
            Join the hundreds of families who've discovered what makes NWBBA
            special.
          </p>
          <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors" data-id="element-379">
            Start Your $29 Trial
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-380">
        <div className="max-w-4xl mx-auto" data-id="element-381">
          <div className="font-black text-xl text-white mb-4 tracking-tighter" data-id="element-382">
            NWBBA
          </div>
          <p className="mb-6" data-id="element-383">Northwest Black Belt Academy</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-8" data-id="element-384">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-385">
              Home
            </Link>
            <Link to="/about" className="hover:text-white transition-colors" data-id="element-386">
              About
            </Link>
            <Link to="/classes" className="hover:text-white transition-colors" data-id="element-387">
              Classes
            </Link>
            <Link to="/schedule" className="hover:text-white transition-colors" data-id="element-388">
              Schedule
            </Link>
            <Link to="/resources" className="hover:text-white transition-colors" data-id="element-389">
              Resources
            </Link>
            <Link to="/blog" className="hover:text-white transition-colors" data-id="element-390">
              Blog
            </Link>
            <Link to="/proof" className="text-white font-bold" data-id="element-391">
              Proof
            </Link>
            <a href="#" className="hover:text-white transition-colors" data-id="element-392">
              Contact
            </a>
          </div>
          <p data-id="element-393">
            &copy; {new Date().getFullYear()} Northwest Black Belt Academy. All
            rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}